import React from 'react';
import { Icon, Text, FlexCrate } from '@perch-labs/shrike';
import { copyFor } from 'config';
import { IconContainer } from './plans-placeholder.style';

const getCopy = copyFor('settings.membership');

export const PlansPlaceholder = ({ type }) => {
  return (
    <FlexCrate
      backgroundColor="primary"
      border={{
        width: '1px',
        color: 'tertiary',
        style: 'solid',
      }}
      borderRadius="8px"
      margin={{ top: '28px' }}
      padding="40px"
      alignItems="center"
      justifyContent="center"
    >
      <IconContainer>
        <Icon color="secondary" icon="ExclamationCircleInverted" />
        <Text textStyle="paragraph400" tag="p" color="secondary">
          {getCopy('tabs.noPlansToShow', { type })}
        </Text>
      </IconContainer>
    </FlexCrate>
  );
};
